import classNames from 'classnames';
import { textPreset } from '../constants';
import { ITextProps, TextPreset } from '../types';
import { localeStore } from 'src/mobx/localesStore';
import { getTranslate } from 'src/utils/helpers';

export const getText = ({ text, noTranslate, quantity, defaultValue = '-' }: ITextProps): string | number => {
  if (!text && text !== 0) return defaultValue;
  const isString: boolean = typeof text === 'string';

  let _text: string | number = '';

  switch (true) {
    case noTranslate && isString:
      _text = text as string;
      break;
    case isString:
      _text = localeStore.t(text as string);
      break;
    case typeof text === 'number':
      _text = text as string;
      break;
    default:
      _text = getTranslate(text as string);
      break;
  }

  if (quantity) return `${_text} x${quantity}`;
  return _text;
};

export const getTextStyle = (props: ITextProps): string => {
  return classNames(
    textPreset[props.type],
    {
      'input-error': props.error || props.type === TextPreset.ERROR,
      'color-red': props.error && props.type !== TextPreset.ERROR,
      required: props.required,
      'opacity-50': props.disabled,
    },
    props.className
  );
};
